import { jsx as _jsx } from "react/jsx-runtime";
import { SectionList } from "native-base";
import { useState } from "react";
import { useWindowDimensions } from "react-native";
import ListHeader from "../../molecules/ListHeader";
import InsulinMeasurementListItem from "../../molecules/ListItem/InsulinMeasurementListItem";
const InsulinMeasurementContentMobile = ({ sections, onDeletePress, onEditPress, onEndReached, }) => {
    const [flatListPosition, setFlatListPosition] = useState(0);
    const screenHeight = useWindowDimensions().height;
    return (_jsx(SectionList, { onLayout: (event) => flatListPosition === 0
            ? setFlatListPosition(event.nativeEvent.layout.y)
            : null, scrollEventThrottle: 16, onScroll: (event) => {
            const { contentOffset, layoutMeasurement, contentSize } = event.nativeEvent;
            const paddingToBottom = 20;
            if (layoutMeasurement.height + contentOffset.y >=
                contentSize.height - paddingToBottom) {
                onEndReached === null || onEndReached === void 0 ? void 0 : onEndReached();
            }
        }, maxHeight: screenHeight - flatListPosition - 4, width: "full", minWidth: "full", showsVerticalScrollIndicator: false, sections: sections, renderSectionHeader: ({ section: { header } }) => {
            if (!header)
                return null;
            const { title, badge } = header;
            return _jsx(ListHeader, { title: title, badge: badge });
        }, renderItem: ({ item }) => (_jsx(InsulinMeasurementListItem, Object.assign({}, item, { onDeletePress: onDeletePress, onEditPress: onEditPress }))), keyExtractor: (item, index) => `section-list-item-${index}`, stickySectionHeadersEnabled: true }));
};
export default InsulinMeasurementContentMobile;
